<template>
	<company-explorer></company-explorer>
</template>
<script>
	import companyExplorer from "@/components/webComponents/widget/companyExplorer/companyExplorer.vue";
	export default {
		components: {
			companyExplorer
		}
	};
</script>